module.exports = __webpack_public_path__ + "static/media/5-fullt.8c201131.mp3";